module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M9.803 0h8.372c1.159 0 1.811.889 1.811 1.986v14.002h6.847c1.157 0 1.495.628.755 1.467L15.331 31.373c-.739.843-1.943.829-2.682-.012L.392 17.465c-.739-.843-.402-1.477.755-1.477h6.847V1.986C7.994.889 8.646 0 9.803 0z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/down-arrow-2.js
// module id = 1109
// module chunks = 14